<template>
  <div>
    <send-notification-modal v-if="isSendingNotificationModalOpen"
                             :recipient-id="userToSendNotificationId"
                             :recipient-name="userToSendNotificationName"
                             @close="closeSendingNotificationModal"/>
    <Teleport :to="'#internal-notifications-container'">
      <div class="container p-0 relative mx-auto">
        <div class="fixed flex flex-col items-center bottom-8 gap-y-2 w-fit z-modal left-1/2 -translate-x-1/2
                        xl:left-auto xl:translate-x-0">
          <TransitionGroup name="slide-fade">
            <toast-notification v-for="notification in internalNotifications"
                                :key="notification.id"
                                :data="notification"
                                @remove="removeNotification"/>
          </TransitionGroup>
        </div>
      </div>
  <!--    <button @click="() => window.setTimeout(testInternal, 500)" class="fixed z-modal bottom-12 left-2">TESTUJ POWIADOMIENIA WEWNĘTRZNE</button>-->
  <!--    <button @click="() => window.setTimeout(testExternal, 500)" class="fixed z-modal bottom-8 left-2 z-modal">TESTUJ POWIADOMIENIA ZEWNĘTRZNE</button>-->
  <!--    <button @click="() => window.setTimeout(addBonusNotification, 500)" class="fixed z-modal bottom-0 left-2">TESTUJ POWIADOMIENIA BONUSU</button>-->
    </Teleport>
    <div class="absolute z-[9999] w-full" :class="[ visibleAdminBar ? 'top-[52px]' : 'top-[20px]' ]">
      <div class="container p-0 relative mx-auto">
        <div class="fixed flex flex-col items-center gap-y-2 left-1/2 -translate-x-1/2 w-fit z-modal">
          <TransitionGroup name="slide-fade">
            <toast-notification v-for="notification in externalNotifications"
                                :key="notification.id"
                                :data="notification"
                                @remove="removeNotification"/>
          </TransitionGroup>
        </div>
      </div>
    </div>
    <div class="xl:w-[896px]">
      <div v-if="Number(WP.id) === 20097 || Number(WP.id) === 193"
           class="fixed z-modal left-[50%] -translate-x-1/2 xl:relative xl:top-4"
           :class="[ visibleAdminBar ? 'top-[102px]' : 'top-[70px]' ]">
        <div class="flex flex-col items-center gap-y-2">
          <BonusNotification v-for="notification in bonusNotifications"
                             :key="notification.id"
                             :data="notification"
                             @remove="removeNotification"
                             @click="notification.onClick" />
        </div>
      </div>
    </div>

    <teleport to="body">
      <div v-if="window.size.mobile && occasionalPopup.isOpen && WP.id !== 90245
                  && !!Number(occasionalPopup.data.show_in_martial_sports) === isMartialSports"
           class="fixed z-modal left-[50%] -translate-x-1/2 w-full rounded-zt" :class="[visibleAdminBar ? 'top-[46px]' : 'top-[14px]']">
        <OccasionalBonusPopup @close="closeOccasionalPopup" :data="occasionalPopup.data"/>
      </div>
    </teleport>
  </div>
</template>

<script>
import { defineAsyncComponent } from 'vue';
import utils_mixin from '../mixins/utils_mixin';
import { Notice } from '../../assets/js/Notice';
import OccasionalBonusPopup from './notifications/OccasionalBonusPopup.vue';
import SendNotificationModal from './modals/SendNotificationModal.vue';

export default {
  name: 'NotificationPanel',
  inject: ['WP'],
  mixins: [utils_mixin],
  components: {
    SendNotificationModal,
    ToastNotification: defineAsyncComponent(() => import('./notifications/ToastNotification.vue')),
    BonusNotification: defineAsyncComponent(() => import('./notifications/BonusNotification.vue')),
    OccasionalBonusPopup
  },
  data() {
    return {
      visibleAdminBar: window.PHP.visibleAdminBar,
      occasionalPopup: {
        data: null,
        isOpen: false,
      },
      isSendingNotificationModalOpen: false,
      userToSendNotificationId: 0,
      userToSendNotificationName: '',
    }
  },
  mounted() {
    this.addWSListeners();
    this.showNotificationToUser();
		this.loadActivePopups();
    this.emitter.on('openSendingNotificationModal', this.openSendingNotificationModal);
  },
  computed: {
    externalNotifications() {
      if (window.notifications.length) {
        return window.notifications.filter(notification => notification.source === 'external');
      } else {
        return [];
      }
    },
    internalNotifications() {
      if (window.notifications.length) {
        return window.notifications.filter(notification => notification.source === 'internal');
      } else {
        return [];
      }
    },
    bonusNotifications() {
      if (window.notifications.length) {
        return window.notifications.filter(notification => notification.source === 'bonus').slice(0, 1);
      } else {
        return [];
      }
    },
		isMartialSports() {
      for (let category of this.WP.categories) {
        if (category.cat_ID === 806 || category.category_parent === 806) {
          return true;
        }
      }
			return false;
		}
  },
  methods: {
    closeOccasionalPopup() {
      this.occasionalPopup.isOpen = false;
    },
		loadActivePopups() {
			axios
				.post(this.WP.ajaxUrl, {
					endpoint: 'api_get_latest_occasional_popups',
				})
				.then(response => {
					if (response.data.success) {
            for (let popUp of response.data.data) {
              if (!!Number(popUp.show_in_martial_sports) === this.isMartialSports) {
                this.occasionalPopup.data = popUp;
                const wasSeen = localStorage.getItem(`occasional-popup-${popUp.id}`);
                if (!wasSeen) {
                  setTimeout(() => {
                    if (!!Number(this.occasionalPopup.data.show_in_martial_sports) === this.isMartialSports) {
                      localStorage.setItem(`occasional-popup-${popUp.id}`, 'seen');
                    }
                    this.occasionalPopup.isOpen = true;
                  }, 10000);
                }
              }
            }
					}
				})
		},
    testInternal() {
      this.addInternalNotification(new Notice()
        .setContent('Zaobserwowałeś użytkownika')
        .setIcon('copy')
        .setDismissTime(9999999));
    },
    testExternal() {
      this.addExternalNotification(new Notice()
        .setContent('Dodano nowy Typ! ' + this.DateTime.now().toSeconds())
        .setIcon('new_bet')
        .setDismissTime(9999999));
    },
    addBonusNotification() {
      let bookmaker = Number(this.WP.id) === 20097 ? 'betclic' : 'fortuna';
      this.addNotification(new Notice()
        .setSource('bonus')
        .setDismissTime(3000)
        .setBookmaker(bookmaker));
    },
    addWSListeners() {
      if (Number(this.WP.id) === 20097 || Number(this.WP.id) === 193) {
        window.socket?.on('button-bonus-received', (data) => {
          this.addBonusNotification();
          const storageObject = {};
          storageObject[this.WP.id] = this.DateTime.now().toMillis() + 172800000;
          localStorage.setItem('bonus-timestamps', JSON.stringify(storageObject));
        });
      }
      window.socket?.on('bonus-popup', (data) => {
        this.occasionalPopup.data = data;
        this.occasionalPopup.isOpen = true;
				if (!!Number(this.occasionalPopup.data.show_in_martial_sports) === this.isMartialSports) {
					localStorage.setItem(`occasional-popup-${ this.occasionalPopup.data.id }`, 'seen');
				}
      })
    },
    removeNotification(id) {
      let index = window.notifications.findIndex(notification => notification.id === id);
      if (index !== -1) {
        window.notifications.splice(index, 1);
      }
    },
    showNotificationToUser() {
      const jsonObject = localStorage.getItem('bonus-timestamps');
      let timestamp = 0;
      if (jsonObject) {
        timestamp = jsonObject[this.WP.id];
      }
      if (!window.PHP.bot && timestamp < this.DateTime.now().toMillis()) {
        const storageObject = {};
        storageObject[this.WP.id] = this.DateTime.now().toMillis() + 172800000;

        let num = Math.random();
        let dt = new Date();
        if (dt.getHours() > 7) {
          //5% chance to show notification during the day
          if (num < 0.15) { // tymczasowa zmiana na 15%
            setTimeout(() => {
              this.addBonusNotification();
              this.saveReceivedBonus();
            }, (Math.random() * (15000 - 30000 + 1) + 15000));
          }
          localStorage.setItem('bonus-timestamps', JSON.stringify(storageObject));
        }
        else {
          //3% chance to show notification during the night
          if (num < 0.09) { // tymczasowa zmiana na 9%
            setTimeout(() => {
              this.addBonusNotification();
              this.saveReceivedBonus();
            }, 10000);
            localStorage.setItem('bonus-timestamps', JSON.stringify(storageObject));
          }
        }
      }
    },
    saveReceivedBonus() {
        axios.post(this.WP.ajaxUrl, {
            endpoint: 'api_save_received_bonus',
            bookmaker: Number(this.WP.id) === 20097 ? 'betclic' : 'fortuna',
            date: new Date(),
            type: 'bot'
        })
        .then(response => {
            // if (response.data.success) {
            //     socket?.emit('bonus-received', {
            //         bookmaker: Number(this.WP.id) === 20097 ? 'betclic' : 'fortuna',
            //     });
            // }
        });
    },
    openSendingNotificationModal(userData) {
      this.blockScrolling();
      this.isSendingNotificationModalOpen = true;
      if (userData) {
        const { userId, userName } = userData;
        this.userToSendNotificationId = userId;
        this.userToSendNotificationName = userName;
      }
    },
    closeSendingNotificationModal() {
      this.unblockScrolling();
      this.isSendingNotificationModalOpen = false;
    }
  }
};
</script>

<style scoped>
.slide-fade-move,
.slide-fade-enter-active,
.slide-fade-leave-active {
  transition: all 0.5s ease;
}

.slide-fade-enter-from,
.slide-fade-leave-to {
  transform: translateX(20px);
  opacity: 0;
}

.slide-fade-leave-active {
  position: absolute;
  min-width: max-content;
}
</style>